export const hardwareCopy = {
  "en-GB": {
    "hardware.accepted": "Request accepted. Follow the tracker reply and any new report below.",
    "local.error.hardwareOutcomeUnknown": "The connection was interrupted. Refresh to check whether the change was saved before trying again.",
    "hardware.measure": "Measure once",
    "hardware.measureHelp": "Wear the bracelet against your skin and keep your arm still. You can start another measurement as soon as the result arrives.",
    "hardware.inProgress": "Measurement in progress",
    "hardware.elapsedHelp": "Elapsed time. Keep your arm still while we wait for the result.",
    "hardware.completedIn": "Reading received after {seconds} sec.",
    "hardware.measurementBusy": "In progress: {measurement}. The next measurement becomes available when its result arrives.",
    "hardware.measuring.heartPressure": "The bracelet is measuring heart rate and blood pressure…",
    "hardware.measuring.temperature": "The bracelet is measuring temperature…",
    "hardware.measuring.oxygen": "Waiting for the bracelet's oxygen measurement…",
    "hardware.measureTogether": "Measure with heart rate and blood pressure",
    "hardware.reportNote": "Device readings are indicative. Do not use them for diagnosis or treatment.",
    "hardware.latest": "Latest reading",
    "hardware.noReport": "No reading received yet.",
    "hardware.pressure": "Blood pressure",
    "hardware.oxygenPassive": "The oxygen reading starts with heart rate and blood pressure and appears when ready.",
    "hardware.unavailable": "This setting cannot be changed on this device.",
    "hardware.wait": "Next request available in {seconds} s.",
    "hardware.confirm": "Send to {name}?",
    "hardware.send": "Send request",
    "hardware.cancel": "Cancel",
    "hardware.requested": "Last request",
    "hardware.settingNote": "Shows your last choice. Check on the device that the change works as expected.",
    "hardware.steps": "Step counter",
    "hardware.stepsHelp": "Enable or disable the bracelet's own counter. Its counting schedule is separate. GPS-derived estimates continue to use your activity profile.",
    "hardware.removalHelp": "Send a text message when the device detects removal. Recipients follow the device's text-message settings. App notifications are selected separately.",
    "hardware.removalSms": "Removal SMS",
    "hardware.on": "Enable",
    "hardware.off": "Disable",
    "hardware.scene.1": "Sound and vibration",
    "hardware.scene.2": "Sound",
    "hardware.scene.3": "Vibration",
    "hardware.scene.4": "Silent",
    "hardware.sceneHelp": "Choose a sound profile for the bracelet, then check it on the device.",
    "hardware.progress.idle": "No request sent.",
    "hardware.progress.queued": "Request queued for the bracelet.",
    "hardware.progress.waitingReply": "Sent. Waiting for the bracelet to reply…",
    "hardware.progress.waitingMeasurement": "The bracelet replied. Waiting for a measurement…",
    "hardware.progress.waitingWithoutReply": "Still waiting for a reading…",
    "hardware.progress.reportAfterRequest": "A new reading was received.",
    "hardware.progress.invalidReport": "The reading could not be displayed. Try again.",
    "hardware.progress.measurementTimeout": "No new reading after two minutes. Check skin contact and refresh. The reading may still arrive later.",
    "hardware.progress.replyTimeout": "The device did not reply. The setting may have changed; check it before trying again.",
    "hardware.progress.settingReply": "The bracelet replied to the setting request.",
    "hardware.progress.replyUnavailable": "The previous setting cannot be shown after the ownership change.",
    "hardware.progress.failed": "The device could not be reached. Try again when it is online.",
    "hardware.quality.reported": "Reported values",
    "hardware.quality.invalid_value": "The reading could not be displayed. Try again.",
    "hardware.quality.unsupported_format": "The reading could not be displayed. Contact Qtracker if it happens again.",
    "hardware.quality.temperature_low_error": "The bracelet reported a low-temperature measurement error.",
    "hardware.quality.temperature_high_error": "The bracelet reported a high-temperature measurement error.",
    "hardware.mode.wrist": "Wrist mode",
    "hardware.mode.forehead": "Forehead mode",
    "hardware.history": "Previous readings",
    "hardware.alarm.removal": "Bracelet removal alarm",
    "hardware.alarm.low_battery": "Bracelet low-battery alarm",
    "hardware.alarm.abnormal_heart_rate": "Bracelet heart-rate alarm",
    "hardware.alarm.pulse_limit": "Pulse outside your chosen limits",
    "hardware.alarm.measurement_pulse_limit": "Pulse outside your chosen limits",
    "hardware.alarm.measurement_pressure_limit": "Blood pressure outside your chosen limits",
    "hardware.alarm.measurement_temperature_limit": "Temperature outside your chosen limits",
    "hardware.alarm.measurement_oxygen_limit": "Oxygen saturation outside your chosen limits",
    "hardware.live": "Available",
  },
  "da-DK": {
    "hardware.accepted": "Anmodningen er modtaget. Følg armbåndets svar og eventuelle nye rapport nedenfor.",
    "local.error.hardwareOutcomeUnknown": "Forbindelsen blev afbrudt. Opdatér for at se, om ændringen blev gemt, før du prøver igen.",
    "hardware.measure": "Mål én gang",
    "hardware.measureHelp": "Bær armbåndet mod huden, og hold armen i ro. Du kan starte en ny måling, så snart resultatet kommer.",
    "hardware.inProgress": "Måling i gang",
    "hardware.elapsedHelp": "Forløbet tid. Hold armen i ro, mens vi venter på resultatet.",
    "hardware.completedIn": "Måling modtaget efter {seconds} sek.",
    "hardware.measurementBusy": "I gang: {measurement}. Du kan starte næste måling, når resultatet er modtaget.",
    "hardware.measuring.heartPressure": "Armbåndet måler puls og blodtryk…",
    "hardware.measuring.temperature": "Armbåndet måler temperaturen…",
    "hardware.measuring.oxygen": "Afventer armbåndets iltmåling…",
    "hardware.measureTogether": "Mål sammen med puls og blodtryk",
    "hardware.reportNote": "Vejledende målinger fra enheden. Brug dem ikke som grundlag for diagnose eller behandling.",
    "hardware.latest": "Seneste måling",
    "hardware.noReport": "Ingen måling modtaget endnu.",
    "hardware.pressure": "Blodtryk",
    "hardware.oxygenPassive": "Iltmålingen starter sammen med puls og blodtryk og vises, når den er klar.",
    "hardware.unavailable": "Indstillingen kan ikke ændres på denne enhed.",
    "hardware.wait": "Næste anmodning er mulig om {seconds} sek.",
    "hardware.confirm": "Send til {name}?",
    "hardware.send": "Send anmodning",
    "hardware.cancel": "Annuller",
    "hardware.requested": "Seneste anmodning",
    "hardware.settingNote": "Viser dit seneste valg. Kontrollér på enheden, at ændringen virker som ønsket.",
    "hardware.steps": "Skridttæller",
    "hardware.stepsHelp": "Aktivér eller deaktivér armbåndets egen tæller. Tællingens tidsplan er en særskilt indstilling. GPS-estimater bruger fortsat din aktivitetsprofil.",
    "hardware.removalHelp": "Send SMS, når enheden registrerer, at den bliver taget af. Modtagerne følger enhedens SMS-indstillinger. Beskeder fra appen vælges separat.",
    "hardware.removalSms": "SMS ved aftagning",
    "hardware.on": "Aktivér",
    "hardware.off": "Deaktivér",
    "hardware.scene.1": "Lyd og vibration",
    "hardware.scene.2": "Lyd",
    "hardware.scene.3": "Vibration",
    "hardware.scene.4": "Lydløs",
    "hardware.sceneHelp": "Vælg armbåndets lydprofil, og kontrollér den derefter på enheden.",
    "hardware.progress.idle": "Ingen anmodning sendt.",
    "hardware.progress.queued": "Anmodningen er i kø til armbåndet.",
    "hardware.progress.waitingReply": "Sendt. Venter på armbåndets svar…",
    "hardware.progress.waitingMeasurement": "Armbåndet har svaret. Venter på en måling…",
    "hardware.progress.waitingWithoutReply": "Venter stadig på en måling…",
    "hardware.progress.reportAfterRequest": "En ny måling er modtaget.",
    "hardware.progress.invalidReport": "Målingen kunne ikke vises. Prøv igen.",
    "hardware.progress.measurementTimeout": "Ingen ny måling efter to minutter. Kontrollér kontakten til huden, og opdatér. Målingen kan stadig komme senere.",
    "hardware.progress.replyTimeout": "Enheden svarede ikke. Indstillingen kan være ændret; kontrollér den, før du prøver igen.",
    "hardware.progress.settingReply": "Armbåndet har svaret på ændringsanmodningen.",
    "hardware.progress.replyUnavailable": "Den tidligere indstilling kan ikke vises efter ejerskiftet.",
    "hardware.progress.failed": "Enheden kunne ikke kontaktes. Prøv igen, når den er online.",
    "hardware.quality.reported": "Rapporterede værdier",
    "hardware.quality.invalid_value": "Målingen kunne ikke vises. Prøv igen.",
    "hardware.quality.unsupported_format": "Målingen kunne ikke vises. Kontakt Qtracker, hvis det sker igen.",
    "hardware.quality.temperature_low_error": "Armbåndet rapporterede målefejl for lav temperatur.",
    "hardware.quality.temperature_high_error": "Armbåndet rapporterede målefejl for høj temperatur.",
    "hardware.mode.wrist": "Håndledstilstand",
    "hardware.mode.forehead": "Pandetilstand",
    "hardware.history": "Tidligere målinger",
    "hardware.alarm.removal": "Aftagningsalarm fra armbåndet",
    "hardware.alarm.low_battery": "Batterialarm fra armbåndet",
    "hardware.alarm.abnormal_heart_rate": "Pulsalarm fra armbåndet",
    "hardware.alarm.pulse_limit": "Puls uden for dine valgte grænser",
    "hardware.alarm.measurement_pulse_limit": "Puls uden for dine valgte grænser",
    "hardware.alarm.measurement_pressure_limit": "Blodtryk uden for dine valgte grænser",
    "hardware.alarm.measurement_temperature_limit": "Temperatur uden for dine valgte grænser",
    "hardware.alarm.measurement_oxygen_limit": "Iltmætning uden for dine valgte grænser",
    "hardware.live": "Tilgængelig",
  },
};
